import { dateFormatMap } from '@op/constants';
import { formatTime, toPercentNumber } from '../../render-helper';

export default function steamRealtimeColumns(title: string) {

  return (params: any) => {
    const { date_type } = params;
    return [
      {
        renderHelper: [formatTime(dateFormatMap[date_type])],
        header: 'Date',
        render: 'time',
      },
      {
        header: title,
        render: 'new_review',
      },
      {
        header: `Positive%`,
        render: 'new_score',
        renderHelper: [toPercentNumber(false)],
        numFmt: '0.00%',
      },
      {
        renderHelper: [formatTime(dateFormatMap[date_type])],
        header: 'This time period',
        render: 'old_time',
      },
      {
        header: `${title} The previous corresponding period`,
        render: 'old_review',
      },
      {
        header: `Positive% The previous corresponding period`,
        render: 'old_score',
        renderHelper: [toPercentNumber(false)],
        numFmt: '0.00%',
      },
    ];
  }
}
